import React from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import PropTypes from "prop-types";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "code"],
    ["clean"],
  ],
};

const formats = ["header", "bold", "italic", "underline", "strike", "list", "bullet", "link", "code"];

const TextEditor = ({ value, onChange, placeholder }) => (
  <div style={{ height: 150 }}>
    <ReactQuill
      style={{ height: 100 }}
      theme="snow"
      value={value}
      onChange={onChange}
      modules={modules}
      formats={formats}
      placeholder={placeholder}
    />
  </div>
);

export default TextEditor;

TextEditor.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};
